import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import useHelper from "../../components/_common/useHelper";
import { useTranslation } from "react-i18next";

import { makeStyles, useTheme } from "@material-ui/styles";
import {
    alpha,
    AppBar,
    Box,
    Card,
    CardContent,
    // eslint-disable-next-line
    Divider,
    List,
    ListItem,
    ListItemText,
    Tab,
    Tabs,
} from "@material-ui/core";

const BORDERED_LAYOUT = process.env.REACT_APP_BORDERED_LAYOUT
    ? JSON.parse(process.env.REACT_APP_BORDERED_LAYOUT)
    : false;
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`abouts-full-width-tabpanel-${index}`}
            // aria-labelledby={`abouts-full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `abouts-full-width-tab-${index}`,
        "aria-controls": `abouts-full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
    tabTitle: {
        textTransform: "none",
        fontWeight: 500,
        lineHeight: 1.4,
        fontSize: "clamp(13px, 1vw, 1rem)",
        [theme.breakpoints.down("sm")]: {
            // fontSize: "0.5rem",
            display: "none",
        },
    },
    tabTitleMobile: {
        textTransform: "none",
        fontWeight: 600,
        lineHeight: 1.4,
        fontSize: "1.125rem",
        color: theme.palette.primary.main,
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
    },
    tabImg: {
        maxWidth: 72,
        [theme.breakpoints.down("sm")]: {
            maxWidth: 48,
        },
    },
    tabRoot: {
        alignItems: "baseline",
        borderRadius: BORDERED_LAYOUT ? theme.spacing(4.5, 4.5, 0, 0) : 0,
        "&:focus-visible": {
            outline: "#000 auto 2px",
        },
    },
    tabRootActive: {
        border: BORDERED_LAYOUT ? "1px solid #00000033" : "none",
        borderBottomColor: BORDERED_LAYOUT ? "#FFF" : "inherit",
        backgroundColor: "#FFF",
    },

    tabPanelActive: {
        border: BORDERED_LAYOUT ? "1px solid #00000033" : "none",
        borderRadius: BORDERED_LAYOUT ? theme.spacing(0, 0, 4.5, 4.5) : 0,
        marginTop: -1,
    },
    tabPanelText: {
        [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
        },
    },
    title: {
        display: "flex",
        alignItems: "center",
    },
    titleIcon: {
        margin: theme.spacing(0, 2, 0, 2),
    },
    listItemAvatarAvatar: {
        backgroundColor: alpha(theme.palette.primary.light, 0.125),
        color: theme.palette.primary.main,
    },
    bigTitle: {
        margin: theme.spacing(10, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
    },
    listRoot: {
        // display: "flex",
        // flexWrap: "wrap",
        // alignItems: "flex-start",
    },
    listItem: {
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        alignItems: "flex-start",
        flexWrap: "wrap",
        boxShadow: theme.shadows[0],
        margin: "0 1%",
    },
    listItemLI: {
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            padding: 0,
            fontSize: "0.875rem",
        },
        "& span": {
            [theme.breakpoints.down("sm")]: {
                fontSize: "1rem",
            },
        },
        "& p": {
            [theme.breakpoints.down("sm")]: {
                fontSize: "1rem",
            },
        },
    },
    listItemTextPrimary: {
        fontWeight: theme.typography.fontWeightBold,
        fontSize: "1.25rem",
    },
    listItemTextSecondary: {
        fontSize: "1.25rem",
    },
    card: {
        margin: theme.spacing(1, 5, 5, 5),
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(0),
        },
    },
    cardHeader: {
        backgroundColor: alpha(theme.palette.primary.light, 0.125),
    },
    cardHeaderTitle: {},
    cardContent: {
        fontSize: "1.25rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
        },
    },
    tabIndicator: {
        maxWidth: "17%",
        minWidth: "17%",
        marginLeft: "4%",
        "& span": {
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: `6px solid ${theme.palette.primary.main}`,
            position: "absolute",
            top: 1,
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
    overflowVisible: {
        overflow: "visible!important",
        borderRadius: BORDERED_LAYOUT ? theme.spacing(4.5, 4.5, 0, 0) : 0,
        backgroundColor: BORDERED_LAYOUT ? "#00000003" : "inherit",
    },
    olList: {
        padding: 0,
        "& li": {
            listStyle: "none",
        },
    },
}));

const TabsAbout = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const { i18n } = useTranslation();
    const { translationFromJson } = useHelper();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" color="transparent" elevation={0}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    classes={{
                        indicator: classes.tabIndicator,
                        root: classes.overflowVisible,
                        fixed: classes.overflowVisible,
                    }}
                    TabIndicatorProps={{ id: "s-l-i", dangerouslySetInnerHTML: { __html: "<span/>" } }}
                >
                    {abouts.map((faq, i) => {
                        return (
                            <Tab
                                key={i}
                                label={
                                    <React.Fragment>
                                        <img className={classes.tabImg} src={faq.icon} alt="" />
                                        <span
                                            className={classes.tabTitle}
                                            dangerouslySetInnerHTML={{ __html: translationFromJson(faq, "title") }}
                                        />
                                    </React.Fragment>
                                }
                                classes={{ root: clsx(classes.tabRoot, i === value && classes.tabRootActive) }}
                                disableRipple
                                {...a11yProps(i)}
                            />
                        );
                    })}
                </Tabs>
            </AppBar>

            <TabPanel
                value={value}
                index={0}
                dir={theme.direction}
                className={clsx(0 === value && classes.tabPanelActive)}
            >
                <div className={classes.tabTitleMobile} dangerouslySetInnerHTML={{ __html: abouts[0].title }} />

                <Card variant="elevation" className={classes.card} elevation={0}>
                    <List className={classes.listRoot} dense={true}>
                        {descriptions.map((description, i) => {
                            return (
                                // <div className={classes.listItem} key={i}>
                                    <ListItem key={i} dense={true} className={classes.listItemLI}>
                                        <ListItemText
                                            primary={
                                                <span tabIndex={i === 0 ? 0 : -1}>
                                                    {translationFromJson(description, "title")}
                                                </span>
                                            }
                                            secondary={
                                                <code style={{ fontFamily: "Fira Sans, sans-serif" }}>
                                                    {translationFromJson(description, "text")}
                                                </code>
                                            }
                                            classes={{
                                                primary: classes.listItemTextPrimary,
                                                secondary: classes.listItemTextSecondary,
                                            }}
                                        />
                                    </ListItem>                                    
                                // </div>
                            );
                        })}
                    </List>
                </Card>
            </TabPanel>

            <TabPanel
                value={value}
                index={1}
                dir={theme.direction}
                className={clsx(1 === value && classes.tabPanelActive)}
            >
                <div className={classes.tabTitleMobile} dangerouslySetInnerHTML={{ __html: abouts[1].title }} />
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <List className={classes.listRoot} dense={true}>
                        {objects.map((object, i) => {
                            return (
                                // <div className={classes.listItem} key={i}>
                                    <ListItem  key={i} dense={true} className={classes.listItemLI}>
                                        <ListItemText
                                            primary={
                                                <span tabIndex={i === 0 ? 0 : -1}>
                                                    {translationFromJson(object, "title")}
                                                </span>
                                            }
                                            secondary={
                                                <code style={{ fontFamily: "Fira Sans, sans-serif" }}>
                                                    {translationFromJson(object, "text")}
                                                </code>
                                            }
                                            classes={{
                                                primary: classes.listItemTextPrimary,
                                                secondary: classes.listItemTextSecondary,
                                            }}
                                        />
                                    </ListItem>
                                    
                                // </div> 
                            );
                        })}
                    </List>
                </Card>
            </TabPanel>

            <TabPanel
                value={value}
                index={2}
                dir={theme.direction}
                className={clsx(2 === value && classes.tabPanelActive)}
            >
                <div className={classes.tabTitleMobile} dangerouslySetInnerHTML={{ __html: abouts[2].title }} />
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <List className={classes.listRoot} dense={true}>
                        {features.map((feature, i) => {
                            return (
                                // <div className={classes.listItem} key={i}>
                                    <ListItem key={i} dense={true} className={classes.listItemLI}>
                                        <ListItemText
                                            primary={
                                                <span tabIndex={i === 0 ? 0 : -1}>
                                                    {translationFromJson(feature, "title")}
                                                </span>
                                            }
                                            secondary={
                                                <code style={{ fontFamily: "Fira Sans, sans-serif" }}>
                                                    {translationFromJson(feature, "text")}
                                                </code>
                                            }
                                            classes={{
                                                primary: classes.listItemTextPrimary,
                                                secondary: classes.listItemTextSecondary,
                                            }}
                                        />
                                    </ListItem>                                    
                                //  </div> 
                            );
                        })}
                    </List>
                </Card>
            </TabPanel>

            <TabPanel
                value={value}
                index={3}
                dir={theme.direction}
                className={clsx(3 === value && classes.tabPanelActive)}
            >
                <div className={classes.tabTitleMobile} dangerouslySetInnerHTML={{ __html: abouts[3].title }} />
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <CardContent className={classes.cardContent}>
                        {i18n.language === "pl" ? (
                            <>
                                {/* <p tabIndex={0}>
                                    Ostatnia całościowa aktualizacja zasobu informacyjnego RSI rozpoczęła się w drugiej
                                    połowie 2021 r. poprzez aktualizację opisów rejestrów i systemów informacyjnych
                                    przez jednostki je prowadzące przy wykorzystaniu aplikacji internetowej RSI.
                                </p> */}
                                <p>
                                    Podstawę prawną pozyskiwania przez GUS metadanych o rejestrach urzędowych i
                                    systemach informacyjnych administracji publicznej stanowią przepisy ustawy z dnia 29
                                    czerwca 1995r. o statystyce publicznej:{" "}
                                </p>
                                <ol className={classes.olList}>
                                    <li>
                                        <p>
                                            <b>Art. 13.</b>
                                        </p>
                                        <p>
                                            1. Organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy
                                            Fundusz Zdrowia, Komisja Nadzoru Finansowego, a także inne państwowe lub
                                            samorządowe osoby prawne, organy rejestrowe oraz inne podmioty prowadzące
                                            rejestry urzędowe lub niepubliczne systemy informacyjne, przekazują lub
                                            udostępniają nieodpłatnie służbom statystyki publicznej zgromadzone dane w
                                            szczegółowym zakresie, postaci i terminach, określonych w programie badań
                                            statystycznych statystyki publicznej, w szczególności w postaci zbiorów
                                            danych z systemów teleinformatycznych, w tym wyników pomiarów, danych
                                            monitoringu środowiska, a w przypadku braku systemu teleinformatycznego - w
                                            innej utrwalonej postaci.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            2. Organy i podmioty, o których mowa w ust. 1, przekazują dane
                                            administracyjne łącznie z informacjami objaśniającymi zawartość informacyjną
                                            tych danych (metadane).
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            3. Organy i podmioty, o których mowa w ust. 1, z wyłączeniem podmiotów
                                            prowadzących niepubliczne systemy informacyjne, są obowiązane do:
                                        </p>
                                    </li>
                                    <li>
                                        <ol>
                                            <li>
                                                <p>
                                                    <b>
                                                        1) przekazywania, na wniosek Prezesa Głównego Urzędu
                                                        Statystycznego, informacji o zawartości informacyjnej
                                                        eksploatowanych systemów informacyjnych administracji publicznej
                                                        oraz rejestrów urzędowych;
                                                    </b>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    2) informowania Prezesa Głównego Urzędu Statystycznego o
                                                    projektowanym zakresie informacyjnym systemów informacyjnych
                                                    administracji publicznej oraz rejestrów urzędowych na etapie ich
                                                    tworzenia lub modernizacji.
                                                </p>
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </>
                        ) : (
                            <>
                                {/* <p>
                                    The last comprehensive update of the RSI information resource began in the second
                                    half of 2021 by updating the descriptions of registers and information systems by
                                    the units that maintain them using the RSI web application.
                                </p> */}
                                <p>
                                    The legal basis for obtaining of metadata about official registers and public
                                    administration information systems by Statistics Poland is provided by the
                                    provisions of the Act of 29 June 1995 on Official Statistics:
                                </p>
                                <p>
                                    Art. 13. 1. Public administration bodies, the Social Insurance Institution, the
                                    National Health Fund, the Polish Financial Supervision Authority, as well as other
                                    state or self-governmental legal entities, registration authorities and other
                                    entities keeping official registers or non-public information systems provide or
                                    make available free of charge to official statistics services the administrative
                                    data in a detailed scope, form and within detailed dates, specified in statistical
                                    survey program of official statistics, in particular in the form of data sets from
                                    teleinformation systems, including measurement results, environmental monitoring
                                    data, and in the absence of a teleinformation system – in another fixed form.
                                </p>
                                <p>
                                    2. The bodies and entities referred to in sec. 1 provide administrative data
                                    together with information explaining the information content of these data
                                    (metadata).
                                </p>
                                <p>
                                    3. The bodies and entities referred to in sec. 1, excluding entities conducting
                                    non-public information systems, are obliged to:
                                </p>
                                <p>
                                    <strong>
                                        2) submit, upon the request of the President of Statistics Poland, information
                                        on the information content of information systems of public administration and
                                        official registers;
                                    </strong>
                                </p>
                                <p>
                                    3) inform the President of Statistics Poland about the planned information scope of
                                    information systems of public administration and official registers at the stage of
                                    their creation or modernisation.
                                </p>
                            </>
                        )}
                    </CardContent>
                </Card>
            </TabPanel>
        </div>
    );
};

export default TabsAbout;

const descriptions = [
    {
        title: "Nazwa systemu",
        title_en: "The name of the system",
        text: "[nazwa pełna ustalona w przepisie prawnym odnoszącym się do systemu; w przypadku braku ww. przepisu nazwa techniczna przyjęta dla systemu; skrócona nazwa, jeśli jest stosowana]",
        text_en:
            "[full name agreed in the legal provision relating to the system; in the absence of the above provision, a technical name adopted for the system; short name, if used]",
    },
    {
        title: "Gestor systemu",
        title_en: "Data owner of the system",
        text: "[jednostka administracji publicznej prowadząca system]",
        text_en: "[public administration unit operating the system]",
    },
    {
        title: "Podstawa prawna",
        title_en: "Legal basis",
        text: "[akty prawne stanowiące podstawę prawną funkcjonowania systemu - jeśli istnieją]",
        text_en: "[legal acts constituting the legal basis for the functioning of the system]",
    },
    {
        title: "Cel systemu",
        title_en: "The purpose of the system",
        text: "[zadanie publiczne, do realizacji którego służy system]",
        text_en: "[public task for which the system is used]",
    },
    {
        title: "Sposób prowadzenia systemu",
        title_en: "The way of running the system",
        text: "[centralny, rozproszony]",
        text_en: "[central, distributed]",
    },
    {
        title: "Zasięg systemu",
        title_en: "System coverage",
        text: "[krajowy, lokalny]",
        text_en: "[national, local]",
    },
    {
        title: "Forma prowadzenia systemu",
        title_en: "The form of running the system",
        text: "[elektroniczna, papierowa, mieszana: elektroniczno-papierowa]",
        text_en: "[electronic, paper, mixed: paper- electronic]",
    },
    {
        title: "Źródła danych i częstotliwość aktualizacji",
        title_en: "Data sources and frequency of updates",
        text: "[źródła wykorzystywane do zasilenia i aktualizacji systemu, np. nazwy dokumentów źródłowych (formularzy, wniosków) i częstotliwość aktualizacji]",
        text_en:
            "[sources used to supply and update the system, e.g. the names of source documents (forms, applications) and the frequency of updates]",
    },
    {
        title: "Termin i formy udostępniania danych",
        title_en: "The date and forms of data sharing",
        text: "[termin dostępności danych zgromadzonych w systemie, forma ich udostępniania]",
        text_en: "[date of availability of data gathered in the system, the form of sharing them]",
    },
    {
        title: "Stan wdrożenia systemu",
        title_en: "System implementation status",
        text: "[wdrożony, niewdrożony, częściowo wdrożony]",
        text_en: "[implemented, not implemented, partially implemented]",
    },
    {
        title: "Zmiany planowane do wprowadzenia w systemie",
        title_en: "Changes to be implemented in the system",
        text: "[planowane zmiany dotyczące zakresu gromadzonych danych, zakres oraz termin wprowadzenia zmian]",
        text_en: "[planned changes in the scope of data collected, scope and timing of changes]",
    },
];

const objects = [
    {
        title: "Nazwa obiektu",
        title_en: "Name of object",
        text: " ",
    },

    {
        title: "Typ obiektu",
        title_en: "The type of object",
        text: "[osoba fizyczna, podmiot, obiekt przestrzenny, inny]",
        text_en: "[a natural person, an entity, a spatial object, another]",
    },
    {
        title: "Opis obiektu w systemie informacyjnym",
        title_en: "Description of object",
        text: "[informacje nt. przedmiotu opisu w systemie]",
        text_en: "[supplementary information about the object]",
    },
    {
        title: "Standardowe identyfikatory obiektu",
        title_en: "Standard object identifiers",
        text: "[numer PESEL, numer identyfikacyjny REGON, numer identyfikacji podatkowej NIP, numer KRS, identyfikator punktu adresowego, identyfikator działki ewidencyjnej, identyfikator jednostki podziału terytorialnego (TERYT), identyfikator miejscowości (TERYT), identyfikator nazw ulic (TERYT).]",
        text_en:
            "[personal identification number (PESEL), identification number of an entity of national economy (REGON), tax identification number (NIP), National Court Register number, address point identifier, registered parcel identifier, administrative division unit identifiers (TERYT), locality identifiers (TERYT), street identifiers (TERYT)]",
    },
];

const features = [
    {
        title: "Nazwa cechy informacyjnej",
        title_en: "Name of the information characteristic",
        text: " ",
    },

    {
        title: "Definicja cechy informacyjnej",
        title_en: "Definition of the information characteristic",
        text: " ",
    },
    {
        title: "Źródło definicji cechy informacyjnej",
        title_en: "Source of the information characteristic definition",
        text: " ",
    },
    {
        title: "Klasyfikacja, słownik powiązany z cechą informacyjną",
        title_en: "Classification, a glossary related to the information characteristic",
        text: "[informacje nt. standardów klasyfikacyjnych i innych klasyfikacji, wykazów i słowników stosowanych w systemie, odnoszących się do cech informacyjnych]",
        text_en:
            "[information on classification standards and other classifications, lists and glossaries used in the system related to information characteristic]",
    },
];

const abouts = [
    {
        id: "1",
        title: "Zakres informacji o systemach gromadzonych w RSI",
        title_en: "Scope of information on the systems gathered in the RSI",
        text: "<p>Repozytorium Systemów Informacyjnych&nbsp; jest bazą wiedzy, obejmującą metadane o systemach informacyjnych administracji publicznej.</p><p>RSI to ustrukturyzowany i zorganizowany zasób informacji. Jest to użyteczne narzędzie do gromadzenia, aktualizacji, udostępniania oraz analizy informacji o systemach informacyjnych administracji publicznej oraz do uzgadniania standardów informacyjnych.</p>",
        icon: "/icons/home/zakres.png",
    },
    {
        id: "2",
        title: "Obiekty opisywane w systemie informacyjnym",
        title_en: "Objects described in the information system",
        text: "<p>Standard informacyjny to norma wprowadzona w drodze porozumienia przez grupę jednostek administracji publicznej, stanowiąca zobowiązanie do stosowania w prowadzonych systemach informacyjnych ustalonych standardów np.: identyfikatorów, klasyfikacji.</p>",
        icon: "/icons/home/obiekty.png",
    },
    {
        id: "3",
        title: "Cechy informacyjne opisujące poszczególne obiekty",
        title_en: "Information characteristics describing particular objects",
        text: "<p>Systemy informacyjne administracji publicznej, tj. systemy zbierania, gromadzenia i przetwarzania informacji przez organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy Fundusz Zdrowia, Komisję Nadzoru Finansowego, organy rejestrowe, inne państwowe lub samorządowe osoby prawne oraz inne podmioty prowadzące rejestry urzędowe.</p>",
        icon: "/icons/home/cechy.png",
    },
    {
        id: "4",
        title: "Aktualizacja RSI",
        title_en: "RSI update",
        text: "<p>Ostatnia całościowa aktualizacja zasobu informacyjnego RSI rozpoczęła się w drugiej połowie 2021 r. poprzez aktualizację opisów rejestrów i systemów informacyjnych przez jednostki je prowadzące przy wykorzystaniu aplikacji internetowej RSI.</p><p>Podstawę prawną pozyskiwania przez GUS metadanych o rejestrach urzędowych i systemach informacyjnych administracji publicznej stanowią przepisy ustawy z dnia 29 czerwca 1995r. o statystyce publicznej: </p><p><b>Art. 13.</b> 1. Organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy Fundusz Zdrowia, Komisja Nadzoru Finansowego, a także inne państwowe lub samorządowe osoby prawne, organy rejestrowe oraz inne podmioty prowadzące rejestry urzędowe lub niepubliczne systemy informacyjne, przekazują lub udostępniają nieodpłatnie służbom statystyki publicznej zgromadzone dane w szczegółowym zakresie, postaci i terminach, określonych w programie badań statystycznych statystyki publicznej, w szczególności w postaci zbiorów danych z systemów teleinformatycznych, w tym wyników pomiarów, danych monitoringu środowiska, a w przypadku braku systemu teleinformatycznego - w innej utrwalonej postaci.</p><p>2. Organy i podmioty, o których mowa w ust. 1, przekazują dane administracyjne łącznie z informacjami objaśniającymi zawartość informacyjną tych danych (metadane).</p><p>3. Organy i podmioty, o których mowa w ust. 1, z wyłączeniem podmiotów prowadzących niepubliczne systemy informacyjne, są obowiązane do:</p><p>1)	przekazywania, na wniosek Prezesa Głównego Urzędu Statystycznego, informacji o zawartości informacyjnej eksploatowanych systemów informacyjnych administracji publicznej oraz rejestrów urzędowych;</p><p>2)informowania Prezesa Głównego Urzędu Statystycznego o projektowanym zakresie informacyjnym systemów informacyjnych administracji publicznej oraz rejestrów urzędowych na etapie ich tworzenia lub modernizacji.</p>",
        icon: "/icons/home/aktualizacja.png",
    },
];
